import {
    calcularQtdDependentesPet, validatorDepPrimeE1, validatorDepPrimeE2, verificarQtdDependentesSemAdicional, verificarQtdDependentesComAdicional, verificarIdadeMembros,
    calcularQtdTotalDependentes, validatorEstrutura2JaCompletada, validatorMaximo1DepComValorAdicional, verificarGrauParentescoRepetidos,
    verificaCondicaoAteLimiteDependentes, verificaCondicaoExcedeLimiteDependentes, validatorPossui2Dependentes75anos,
    comparaRegrasDepAtuaisComDepUpSell
} from './funcoesAuxiliaresZPC';

export class CorrenteCadastroZPC {
    constructor(dependentes, parentesco, categorias, valoresForm, idadeAssociado, subGrupoSelecionadoUpSell) {
        if (subGrupoSelecionadoUpSell) {
            this.dependentes = dependentes.filter(dependente => dependente.Status === true);
        } else {
            this.dependentes = dependentes;
        }

        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.idadeAssociado = idadeAssociado;
        this.subGrupoSelecionadoUpSell = subGrupoSelecionadoUpSell;
    }

    validarRegrasDepAtuaisComDepUpSell() {
        if (this.subGrupoSelecionadoUpSell) {
            const comparacaoDepAtualDepUpSell = comparaRegrasDepAtuaisComDepUpSell(this.dependentes, this.idadeAssociado);

            if (comparacaoDepAtualDepUpSell) {
                this.arrayMsgsErro.push(
                    comparacaoDepAtualDepUpSell
                );
            }
        }

        return this;
    }

    verificaParentescoRepetidos() {
        if (verificarGrauParentescoRepetidos(this.dependentes, this.parentesco)) {
            this.arrayMsgsErro.push('Os dependentes cadastrados e os que serão cadastrados precisam respeitar os parentescos pai, mãe, filhos solteiros + 1 dependente especial');
        }

        return this;
    }

    verificaIdadeMembros() {
        if (verificarIdadeMembros(this.dependentes, this.idadeAssociado)) {
            this.arrayMsgsErro.push('Número de pessoas acima de 75 anos excedido');
        }

        return this;
    }

    verificarLimiteMaxDependentes() {
        if (this.valoresForm.Categoria?.trim() === 'ZELO') {
            if (this.valoresForm.Parentesco !== '5' && this.valoresForm.Parentesco !== '50') {
                if (verificarQtdDependentesSemAdicional(this.dependentes)) {
                    this.arrayMsgsErro.push('');
                    this.arrayMsgsErro.push('Atingiu limite máximo de dependentes sem valor adicional');
                }
            }
        } else {
            if (!['ZPETA', ''].includes(this.valoresForm.Categoria?.trim())) {
                if (verificarQtdDependentesComAdicional(this.dependentes)) {
                    this.arrayMsgsErro.push('Atingiu limite máximo de dependentes com valor adicional');
                }
            }
        }

        return this;
    }

    verificarEstrutura1() {
        if (validatorDepPrimeE1(this.dependentes, this.valoresForm)) {
            this.arrayMsgsErro.push('Para cadastrar acima de 4 dependentes sem valor adicional, os dependentes já cadastrados e os que serão cadastrados precisam respeitar os parentescos pai, mãe, filho, enteado e conjuge');
        }

        return this;
    }

    verificarEstrutura2() {
        if (validatorDepPrimeE2(this.dependentes, this.valoresForm)) {
            this.arrayMsgsErro.push('Para cadastrar acima de 4 dependentes sem valor adicional, os dependentes já cadastrados e os que serão cadastrados precisam respeitar os parentescos pai, mãe, filho, enteado e conjuge');
        }

        return this;
    }

    verificarEstrutura2JaCompletada() {
        if (validatorEstrutura2JaCompletada(this.dependentes, this.valoresForm)) {
            this.arrayMsgsErro.push('limite máximo de dependentes atingidos para estrutura 2');
        }

        return this;
    }

    adicionalPetSomenteParaPets() {
        if (this.valoresForm.Parentesco?.trim() !== 'PET' && (this.valoresForm.Categoria?.trim() === 'ZPETA' && this.valoresForm.Categoria?.trim() !== '')) {
            this.arrayMsgsErro.push('O adicional PET PRIME ADICIONAL é permitido apenas para dependentes do tipo PET.');
        }

        return this;
    }

    verificarMaximo1DepComAdicional() {
        if (validatorMaximo1DepComValorAdicional(this.dependentes, this.valoresForm)) {
            this.arrayMsgsErro.push('É permitido apenas 1 dependente com valor adicional');
        }

        return this;
    }

    possuiAdicionalDependentePet() {
        const qtdDependentesPet = calcularQtdDependentesPet(this.dependentes);
        const qtdTotalDependentes = calcularQtdTotalDependentes(this.dependentes);

        if (verificaCondicaoAteLimiteDependentes(qtdTotalDependentes, qtdDependentesPet, this.valoresForm)) {
            this.arrayMsgsErro.push('Este plano permite dependente PET Sem Valor Adicional ou com valor adicional ZELO PET PRIME caso ultrapasse 4 dependentes.');
        } else if (verificaCondicaoExcedeLimiteDependentes(qtdTotalDependentes, qtdDependentesPet, this.valoresForm)) {
            this.arrayMsgsErro.push('Quantidade total excede 4 dependentes, portanto é necessário selecionar ZELO PET PRIME.');
        }

        return this;
    }

    validaQuantidadeMax75Anos() {
        if (validatorPossui2Dependentes75anos(this.dependentes, this.valoresForm, this.idadeAssociado)) {
            this.arrayMsgsErro.push('Este plano permite apenas 2 dependentes com idade maior ou igual a 75 anos para categoria Sem Valor Adicional e mais 1 dependente com idade maior ou igual a 75 anos para a categoria adicional, o titular também é contabilizado. ');
        }

        return this;
    }

    possui3DependentesPet() {
        const qtdDependentesPet = calcularQtdDependentesPet(this.dependentes);

        if (qtdDependentesPet === 3 && this.valoresForm.Parentesco?.trim() === 'PET' && this.valoresForm.Categoria?.trim() === 'ZPETA') {
            this.arrayMsgsErro.push('Este plano permite apenas 3 dependentes do tipo PET.');
        } else if (qtdDependentesPet === 7 && this.valoresForm.Parentesco?.trim() === 'PET' && this.valoresForm.Categoria?.trim() === 'ZPETA') {
            this.arrayMsgsErro.push('Atingiu o máximo de dependentes PET.');
        }

        return this;
    }
}
